<template>
    <div class="news-detail">
        <banner :config="bannerConfig"></banner>
        <div class="content">
            <h1 class="title" v-html="textParse2(data.title)"></h1>
            <div class="time" v-if="data.sendTime">{{ data.sendTime.split(' ')[0] }}</div>
            <div class="digest" v-if="data.digest" v-html="textParse2(data.digest)"></div>
            <div class="wrap news-detail-html" v-html="data.content"></div>
        </div>
    </div>
</template>

<script setup>
import banner from '~/components/desktop/banner';
import { useI18n } from 'vue-i18n';
import { textParse2 } from '~/assets/js/utils';

const props = defineProps({
    data: {
        type: Object,
        default: () => ({})
    }
})

const { t } = useI18n();

const bannerConfig = {
    bannerType: 4,
    zhTitle: '最新资讯',
    enTitle: 'Latest News'
};
</script>

<style lang="scss">

.news-detail-html {
  // background-color: red !important;

  & > section {
    // text-align: left !important;

    & > section {
      // width: 100% !important;
      // box-shadow: none !important;

      img {
        // box-shadow: rgb(102, 102, 102) 0.2em 0.2em 0.5em !important;
      }
    }
  }
}

</style>

<style lang="scss" scoped>
.news-detail {
    width: 100%;
    display: flex;
    flex-direction: column;

    .content {
        width: 1120px;
        margin: 60px auto 0;

        .title {
            font-weight: bold;
            font-size: 20px;
            color: #000000;
            line-height: 24px;
            text-align: left;
            margin-bottom: 20px;
        }

        .time {
            font-weight: 400;
            font-size: 14px;
            color: #000000;
            text-align: left;
            margin-bottom: 20px;
        }

        .digest {
            border-radius: 10px 10px 10px 10px;
            border: 1px dashed #A6D6C9;
            padding: 20px;
            box-sizing: border-box;
            font-weight: 400;
            font-size: 14px;
            color: #222222;
            line-height: 24px;
            text-align: left;
        }

        .wrap {
            margin-top: 40px;
            margin-bottom: 100px;

            :deep() {
                img {
                    max-width: 1120px;
                    object-fit: contain;
                }
            }
        }
    }
}
</style>